var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";

var Preloader = (_temp = _class = function (_Component) {
  _inherits(Preloader, _Component);

  function Preloader() {
    _classCallCheck(this, Preloader);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Preloader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        color = _props.color,
        size = _props.size,
        otherAttrs = _objectWithoutProperties(_props, ["className", "color", "size"]);

    var classes = ["preloader", className ? className : ""].join(" ");

    return React.createElement(
      "svg",
      _extends({
        width: size,
        height: size,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: classes
      }, otherAttrs),
      React.createElement("rect", { x: "0", y: "0", width: "100", height: "100", fill: "none", className: "bk" }),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line first-line",
          transform: "rotate(0 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(30 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.08333333333333333s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(60 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.16666666666666666s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(90 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.25s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(120 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.3333333333333333s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(150 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.4166666666666667s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(180 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.5s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(210 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.5833333333333334s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(240 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.6666666666666666s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(270 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.75s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(300 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.8333333333333334s",
          repeatCount: "indefinite"
        })
      ),
      React.createElement(
        "rect",
        {
          x: "46.5",
          y: "40",
          width: "7",
          height: "20",
          rx: "5",
          ry: "5",
          fill: color,
          className: "spinner-line",
          transform: "rotate(330 50 50) translate(0 -30)"
        },
        React.createElement("animate", {
          attributeName: "opacity",
          from: "1",
          to: "0",
          dur: "1s",
          begin: "0.9166666666666666s",
          repeatCount: "indefinite"
        })
      )
    );
  };

  return Preloader;
}(Component), _class.defaultProps = {
  color: "#000000",
  size: "32"
}, _temp);
export { Preloader as default };
Preloader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Additional wildcard classes that can be appended to base class
   */
  className: PropTypes.string,
  /**
   * Hex value for color of the spinner
   */
  color: PropTypes.string,
  /**
   * Width and height values of the spinner
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};